import { Button, Drawer, Form, FormInstance, Space, Spin } from 'antd'
import React from 'react'
import { useFormSchemas } from '../hooks'
import { generateFormFieldConfigs, generateFormFields } from '../utils'
import { isCompanyType } from '../utils/entityMappers'

interface CreateDrawerProps {
  open: boolean
  onClose: () => void
  onSubmit: (form: FormInstance) => Promise<void>
  form: FormInstance
  entityType: string
  loading: boolean
}

/**
 * Create drawer component with auto-generated form fields
 */
export const CreateDrawer: React.FC<CreateDrawerProps> = ({
  open,
  onClose,
  onSubmit,
  form,
  entityType,
  loading,
}) => {
  const { data: schemas, isLoading: schemasLoading } = useFormSchemas()

  const handleClose = () => {
    onClose()
    form.resetFields()
  }

  const handleSubmit = async () => {
    await onSubmit(form)
  }

  // Map entity type to schema key (counterparty -> company)
  const schemaKey = isCompanyType(entityType) ? 'company' : entityType
  const columnDefs = schemas?.[schemaKey] ?? []

  // Generate form field configurations
  const fieldConfigs = generateFormFieldConfigs(columnDefs)
  const formFields = generateFormFields(fieldConfigs)

  return (
    <Drawer
      title={`Create New ${entityType.charAt(0).toUpperCase() + entityType.slice(1)}`}
      open={open}
      onClose={handleClose}
      width={520}
      destroyOnClose
      footer={
        <Space style={{ float: 'right' }}>
          <Button onClick={handleClose}>Cancel</Button>
          <Button type='primary' onClick={handleSubmit} loading={loading}>
            Create
          </Button>
        </Space>
      }
    >
      <Form form={form} layout='vertical' autoComplete='off'>
        {schemasLoading ? (
          <div style={{ textAlign: 'center', padding: '24px' }}>
            <Spin />
          </div>
        ) : (
          formFields
        )}
      </Form>
    </Drawer>
  )
}
